<template>
   <div class="container">
     <div id="detail">
      <div class="col-xs-12 app-color" :style="{ '--color' : non_repeat.backgroundColor }">
        <div class="row">
          <div id="baseColor" class="backgroundColor visible-xs" :style="{ '--color' : non_repeat.imageBackgroundColor }">
            <img :data-src="non_repeat.image.url" class="tabs-img lazy">
          </div>
          <img id="appImage" :data-src="non_repeat.image.url" class="tabs-img lazy hidden-xs">
          <div class="backgroundColor hidden-xs" :style="{ '--color' : non_repeat.imageBackgroundColor }"></div>
          <div class="col-md-6 col-xs-12 headline">
            <span id="appHeadline" class="headline" :style="{ '--color' : non_repeat.headlineColor}" v-html="non_repeat.headline"></span>
          </div>
          <Tabs slide-duration="0">
            <template v-for="(repeat, index) in repeats">
              <div class="col-md-6 col-xs-12 tab-title" :key="'repeatable-' + index">
                <TabItem :name="repeat.tabTitle">
                  <template #name>
                    <span v-html="repeat.tabTitle"> </span>
                  </template>
                  <span id="appTitle" class="title" v-html="repeat.title"></span>
                  <span class="title" v-html="repeat.text1"></span>
                  <br/>
                  <br/>
                  <span class="title" v-html="repeat.text2"></span>
                  <br/>
                  <br/>
                  <a :href="repeat.primaryButton.link">
                    <button type="submit" class="btn btn-primary button">{{ repeat.primaryButton.text }}</button>
                  </a>
                </TabItem>
              </div>
            </template>
          </Tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "appSection",
  props: ['non_repeat', 'repeats']
}
</script>

<style scoped lang="scss">

@import "../../css/variables.scss";

.tab-title{
  padding-right: 0;
  padding-left: 0;
  width: 80%;
}
.container{
  margin-top: 140px;
}

.tabs {
  height: auto !important;
}

.row {
  width: 100%;
}

@media (min-width: 991px) {
  .tabs-img {
    width: 556px;
    height: 316px;
    position: absolute;
    margin-top: -145px;
    margin-left: 130px;
    border-bottom-right-radius:12.5rem ;
  }

  .backgroundColor{
    background-color:var(--color);
    width: 556px;
    height: 316px;
    margin-top: -145px;
    margin-left: 130px;
  }

  .app-color {
    height: auto;
    position: relative;
    margin-top: 12%;
    width: 96%;
  }

  .headline {
    margin-top: 15%;
    margin-left: 10%;
    text-transform: none;
  }
  .button {
    font-size: 16px;
    width: 230px;
    margin-bottom: 14rem;
    margin-top: 35px;
  }
}
@media (max-width: $sm-breakpoint-max) {
  .tabs-img {
    width: 100%;
    height: auto;
    border-bottom-right-radius:12.5rem ;
  }
  .backgroundColor{
    background-color:var(--color);
    width: 100%;
    height: auto;
  }
  .headline{
    padding: 0;
  }
  .app-color {
    padding: 0 15px;
  }
  .button {
    font-size: 16px;
    width: 100%;
    margin-bottom: 20px;
  }
  .ml-15 {
    margin-left: 15px;
  }
  .mr-15 {
    margin-right: 15px;
  }
  .container{
    margin-top: 30px;
  }
}
</style>
